import { graphql } from "~/gql";

export const COPY_PRICING = graphql(/* GraphQL */ `
  mutation copyPricing(
    $pricingMatterId: Int!
    $targetMatterId: Int!
    $copyScope: Boolean!
    $copyResourcing: Boolean!
    $rateReplacements: [RateReplacement!]!
  ) {
    copyPricing(
      pricingMatterId: $pricingMatterId
      targetMatterId: $targetMatterId
      copyScope: $copyScope
      copyResourcing: $copyResourcing
      rateReplacements: $rateReplacements
    ) {
      id
      teamMemberships {
        ...TeamMembershipParts
      }
      phases {
        ...PhaseParts
      }
      work {
        ...WorkParts
      }
    }
  }
`);
